var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dash-card"},[_c('div',{staticClass:"dash-card-head flex flex-sb flex-ac"},[_c('div',{staticClass:"heading"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_vm._t("action")],2),_vm._v(" "),_c('div',{staticClass:"dash-card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }